var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23_73",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 48,
    width: 48,
    height: 48,
    transform: "rotate(180 48 48)",
    fill: "#999999"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23_73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 28.5L19 39L39 39L39 9L19 9L19 19.5L16 19.5L16 9C16 8.175 16.2937 7.46875 16.8812 6.88125C17.4687 6.29375 18.175 6 19 6L39 6C39.825 6 40.5312 6.29375 41.1187 6.88125C41.7062 7.46875 42 8.175 42 9L42 39C42 39.825 41.7062 40.5312 41.1187 41.1188C40.5312 41.7063 39.825 42 39 42L19 42C18.175 42 17.4688 41.7063 16.8813 41.1188C16.2938 40.5313 16 39.825 16 39L16 28.5L19 28.5Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 25.6H27.05L22.6 30.05L24.75 32.2L32.85 24.1L24.75 16L22.6 18.15L27.05 22.6H2V25.6Z",
    fill: "#999999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.37dfcc022a324008552e768f1cac92d8.svg";
export { ForwardRef as ReactComponent };